import React, { useState, useEffect } from 'react';
import { useHistory } from "react-router-dom";
import { withTranslation } from 'react-i18next';
import { yupResolver } from "@hookform/resolvers/yup";
import { Helmet } from "react-helmet";
import * as yup from "yup";

import './TimeOut.scss'

import { 
    Button,
    Box,
    Typography
} from '@material-ui/core';

import {
    Navbar,
    Header,
    StepHeader,
    FormBox
} from '../../components/_index';

export default withTranslation()(function TimeOut({t, i18n}) {
    
    const history = useHistory();
    
    const handleBack = () => {
        // history.push("./vehicleDetail");
        history.replace(`${process.env.REACT_APP_SUB_ROUTE}`);
    }
    
    const [dnsData, setDnsData] = useState(null);

    const getDnsData = async () => {
    const response = await fetch(`https://dns.google.com/resolve?name=` + window.location.hostname + `&type=1`);
    const jsonData = await response.json();
        return jsonData;
    };

    useEffect(() => {
        getDnsData().then(data => {
        setDnsData(data);
        }); 
    }, []);

    if (dnsData === null) {
        return null;
    }
    
    const siteID = () => {
        console.log("DNS Status Code: ", dnsData.Status);
        if (dnsData.Status.toString() === "0") {
            if(dnsData.Answer[0].data.toString() === "202.128.244.150") {
                console.log(">>> UAT <<<");
                return "0";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.229.85") {
                console.log(">>> KP Server <<<");
                return "1";
            }
            else if (dnsData.Answer[0].data.toString() === "202.128.244.85") {
                console.log(">>> SP Server <<<");
                return "2";
            }
            else if (dnsData.Answer[0].name.toString() === "epas.td.gov.hk.") {
                if (dnsData.Answer[1].data.toString() === "202.128.229.85") {
                    console.log(">>> KP Server <<<");
                    return "1";
                }
                else if (dnsData.Answer[1].data.toString() === "202.128.244.85") {
                    console.log(">>> SP Server <<<");
                    return "2";
                }
            }
        }
        else {
            console.log(">>> Localhost <<<");
            return "0";
        }
    }
    
    return (
        <main>
            <Helmet>
                <title>{`Screen ID: SC-790-`+siteID()+'-ERR'}</title>
            </Helmet>
            <Box className="wrapper TimeOut">
                <Header />
                <Box className="mainWrapper">
                    <Navbar noStep/>
                    <Box className="contentWrapper">
                        <FormBox header={t('common.timeoutErrTitle')}>
                            <Box className="title">
                              {t('errors.frontend.790-E-0901')}
                            </Box>
                        </FormBox>
                        <FormBox>
                            <Box
                                display="flex"
                                justifyContent="flex-end"
                            >
                                <Button
                                    variant="contained"
                                    color="secondary"
                                    className="secBtn"
                                    onClick={handleBack}
                                >
                                    {t('common.button.back')}
                                </Button>
                            </Box>
                        </FormBox>
                    </Box>
                </Box>
            </Box>
        </main>
    );
});
